import { CampaignCallDurationBucket } from '@/shared/types/campaigns';

export interface HumanCallDurationSplit {
  /** Per bucket, in input order: calls answered by a person and their share of all such calls. */
  buckets: { bucketOrder: number; label: string; humanCount: number; percentage: number }[];
  humanTotal: number;
  /** Measured time on the calls the bars count, in seconds. */
  conversationSeconds: number;
  voicemailSeconds: number;
  /** `conversationSeconds` per call answered by a person; 0 when there are none. */
  averageSeconds: number;
}

/** Drops voicemail from the bars and re-derives the shares, since the server `percentage` includes it. */
export const splitVoicemail = (buckets: CampaignCallDurationBucket[]): HumanCallDurationSplit => {
  const voicemailTotal = buckets.reduce((sum, bucket) => sum + bucket.voicemail_count, 0);
  const humanTotal = Math.max((buckets[0]?.total_count ?? 0) - voicemailTotal, 0);

  let conversationSeconds = 0;
  let voicemailSeconds = 0;
  let conversationCalls = 0;

  const humanBuckets = buckets.map((bucket) => {
    const humanCount = Math.max(bucket.call_count - bucket.voicemail_count, 0);
    conversationSeconds += Math.max(bucket.duration_seconds - bucket.voicemail_duration_seconds, 0);
    voicemailSeconds += bucket.voicemail_duration_seconds;
    conversationCalls += humanCount;

    return {
      bucketOrder: bucket.bucket_order,
      label: bucket.label,
      humanCount,
      percentage: humanTotal > 0 ? (humanCount / humanTotal) * 100 : 0,
    };
  });

  return {
    buckets: humanBuckets,
    humanTotal,
    conversationSeconds,
    voicemailSeconds,
    averageSeconds: conversationCalls > 0 ? conversationSeconds / conversationCalls : 0,
  };
};
